<template>
  <li>
    <label :for="id">{{ label }}</label>
    <div class="form_area">
      <!-- 인풋 포커스 : focus 클래스 추가 -->
      <input
        v-if="inputType == 'tel'"
        :id="id"
        class="form_input"
        :placeholder="placeholder || label + ' 입력'"
        @input="
          ;(input = $event.target.value), $emit('update:modelValue', input)
        "
        v-numeric-only
        @keyup="validateInput"
        @blur="validateInput"
        :maxlength="length"
        :type="inputType"
      />
      <input
        v-else
        :id="id"
        class="form_input"
        :placeholder="placeholder || label + ' 입력'"
        @input="
          ;(input = $event.target.value.trim()),
            $emit('update:modelValue', input)
        "
        @keyup="validateInput"
        @blur="validateInput"
        :maxlength="length"
        :type="inputType"
      />
    </div>
    <div class="form_guide" :class="errors[id] ? 'error' : ''">
      <!-- 에러일 경우 : error 클래스 추가 -->
      <p class="txt_alert">
        <span>{{ errors[id] }}</span>
      </p>
    </div>
  </li>
</template>

<script>
import { ref } from 'vue'
import useFormValidation from '@/common/validation'
export default {
  props: {
    label: String,
    length: String,
    inputType: {
      type: String,
      default: 'text',
    },
    modelValue: String,
    placeholder: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    let input = ref('')
    const { validateNameField, errors, id } = useFormValidation()
    const validateInput = () => {
      validateNameField(props.label, input.value)
    }
    return { input, errors, validateInput, id }
  },
}
</script>
